// moment-timezone relies on `moment` already existing because it monkey-patches `moment.tz`
import moment from 'moment'
import 'moment-timezone'

// moment is the primary export, but generally you want the other util functions instead
export default moment

// uses moment-timezone to guess the current timezone for the user's browser
export const DEFAULT_TIMEZONE = guessTimezone()

/**
 * Convert an `hour` from the given `timezone` into the hour in UTC time.
 *
 * @param hour      The hour to convert.
 * @param timezone  The name of the "local" timezone to convert from.
 * @return          The UTC hour.
 */
export function toUTC(hour: number, timezone: string): number {
  return moment
    .tz(Date.now(), timezone)
    .hour(Number(hour))
    .utc()
    .hour()
}

/**
 * Convert an `hour` to the given `timezone`. (from UTC)
 *
 * @param hour      The UTC hour to convert.
 * @param timezone  The name of the "local" timezone to convert to.
 * @return          The "local" hour.
 */
export function fromUTC(hour: number, timezone: string): number {
  return moment
    .utc(Number(hour), 'H')
    .tz(timezone)
    .hour()
}

/**
 * Gets a list of available timezones.
 */
export function getTimezones() {
  return moment.tz.names()
}

function guessTimezone() {
  try {
    return moment.tz.guess(false)
  } catch (err) {
    return 'UTC'
  }
}
